import React, { useEffect, useState } from 'react';
import { fetchSalesHistory } from '../infrastructure/productApi';
import { useComercialContext } from '../../comercial/ComercialContext';
import { spanishDateFormatter } from '../../ui/components/SpanishDateFormatter';

/**
 * Historial de las últimas ventas de este artículo al cliente por el que actúa
 * el comercial. Solo pedidos hechos por el portal: las ventas por teléfono o
 * directas en BC no están en nuestra base de datos.
 */
export const SalesHistoryComercial = ({ productCode }) => {
    const { actingAsCliente } = useComercialContext();
    const numCliente = actingAsCliente?.numCliente ?? null;
    const [sales, setSales] = useState(null);

    useEffect(() => {
        let cancelled = false;
        if (!numCliente || !productCode) {
            setSales(null);
            return undefined;
        }
        fetchSalesHistory(productCode, numCliente)
            .then(data => { if (!cancelled) setSales(Array.isArray(data) ? data : []); })
            .catch(() => { if (!cancelled) setSales([]); });
        return () => { cancelled = true; };
    }, [productCode, numCliente]);

    if (!numCliente || !sales?.length) return null;

    return (
        <div className="border rounded p-3 bg-light">
            <small className="fw-bold text-secondary d-block mb-2">
                Últimas ventas a {actingAsCliente.nombreRazonSocial ?? 'este cliente'} (solo visible para comerciales)
            </small>
            <table className="table table-sm table-borderless mb-1">
                <thead>
                    <tr className="text-muted" style={{ fontSize: '0.75rem' }}>
                        <th>Fecha</th>
                        <th>Pedido</th>
                        <th className="text-end">Uds</th>
                        <th className="text-end">P. catálogo</th>
                        <th className="text-end">Precio/ud</th>
                        <th className="text-end">Dto.</th>
                    </tr>
                </thead>
                <tbody>
                    {sales.map((sale, i) => (
                        <tr key={`${sale.orderNumber}-${i}`} style={{ fontSize: '0.8rem' }}>
                            <td>{spanishDateFormatter(sale.orderDate)}</td>
                            <td>{sale.orderNumber}</td>
                            <td className="text-end">{sale.quantity}</td>
                            <td className="text-end text-muted">
                                {sale.discountPercent > 0
                                    ? <s>{sale.basePrice?.toFixed(2)}€</s>
                                    : `${sale.basePrice?.toFixed(2)}€`}
                            </td>
                            <td className="text-end">{sale.unitPrice?.toFixed(2)}€</td>
                            <td className="text-end">
                                {sale.discountPercent > 0 ? `${sale.discountPercent}%` : '—'}
                                {sale.combinable && (
                                    <span
                                        className="badge bg-warning text-dark ms-1"
                                        style={{ fontSize: '0.6rem', verticalAlign: 'middle' }}
                                        title="En esta venta se aplicó una oferta combinable del portal"
                                    >
                                        Combinable
                                    </span>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>
                Solo pedidos hechos a través del portal
            </div>
        </div>
    );
};
